var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2872 7.95383C36.9419 8.54994 35.4968 8.95272 33.9775 9.13477C35.5451 8.19677 36.7179 6.72047 37.277 4.98133C35.8042 5.85614 34.1923 6.47192 32.5114 6.80188C31.381 5.59494 29.8838 4.79496 28.2521 4.52615C26.6205 4.25733 24.9458 4.53471 23.4879 5.31523C22.0301 6.09576 20.8707 7.33574 20.1898 8.84268C19.509 10.3496 19.3446 12.0392 19.7224 13.6491C16.7381 13.4993 13.8187 12.7236 11.1536 11.3725C8.48846 10.0213 6.13723 8.12486 4.25249 5.80622C3.60804 6.91788 3.23749 8.20677 3.23749 9.57944C3.23677 10.8152 3.54107 12.0319 4.1234 13.1218C4.70573 14.2117 5.54808 15.1411 6.57571 15.8273C5.38393 15.7894 4.21845 15.4674 3.17627 14.888V14.9847C3.17615 16.7179 3.77565 18.3977 4.87306 19.7391C5.97047 21.0805 7.49819 22.001 9.19699 22.3443C8.09142 22.6435 6.93231 22.6876 5.80721 22.4732C6.28651 23.9644 7.22015 25.2685 8.47741 26.2028C9.73468 27.137 11.2526 27.6548 12.8188 27.6835C10.1602 29.7705 6.87681 30.9026 3.49688 30.8977C2.89816 30.8978 2.29995 30.8629 1.70532 30.7929C5.13614 32.9988 9.12987 34.1695 13.2087 34.165C27.0159 34.165 34.5639 22.7293 34.5639 12.8113C34.5639 12.4891 34.5559 12.1637 34.5414 11.8414C36.0096 10.7797 37.2769 9.46488 38.284 7.95866L38.2872 7.95383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 38.6667,
    fill: "white",
    transform: "translate(0.195068)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTwitter);
export default __webpack_public_path__ + "static/media/lightTwitter.6b54442f8c672aa09556c509be04432f.svg";
export { ForwardRef as ReactComponent };